import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { Observable, Subject, Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { getTypeofCharter } from 'anchor-shared/lib/service/utils/charter-helper';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { CometChatDAO } from '../../../../core/services/dao/cometChatDAO';
import { CometChatGroup } from 'anchor-shared/lib/model/interface/cometChatGroup';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-booking-details-wrapper',
  styleUrls: ['./booking-details-wrapper.component.scss'],
  templateUrl: './booking-details-wrapper.component.html',
})
export class BookingDetailsWrapperComponent implements OnDestroy {
  charter: Charter;
  isMobile: boolean;
  subs: Subscription[] = [];

  constructor(
    private cometChatDAO: CometChatDAO,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
  ) {
    const routeSub = this.route.data.subscribe((data) => {
      const {
        session: { charterResolve },
      } = data;
      this.charter = charterResolve;
    });
    this.subs.push(routeSub);
    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(breakpointSub);
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  navigateBack() {
    this.router.navigate(['manage', 'bookings-manager'], {
      queryParams: { activeTab: getTypeofCharter(this.charter) },
    });
  }

  async goToMessaging() {
    await this.ensureGroupExists(this.charter.id).toPromise();
    this.router.navigate(['manage/messages']);
  }

  ensureGroupExists(charterId): Observable<any> {
    const groupSubject = new Subject();
    this.cometChatDAO.ensureGroupExists(charterId).subscribe({
      next: (group: CometChatGroup) => {
        groupSubject.next();
        groupSubject.complete();
      },
      error: (err) => {
        groupSubject.error(err);
      },
    });

    return groupSubject.asObservable();
  }
}
